import { render, staticRenderFns } from "./CardColors.vue?vue&type=template&id=2c280d3e"
import script from "./CardColors.vue?vue&type=script&lang=js"
export * from "./CardColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports